var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",style:(_vm.wrapperStyle),attrs:{"styleName":"sideMove"}},[_vm._t("default"),_c('div',{ref:"aside",style:(_vm.asideStyle),attrs:{"styleName":"sideWrapper","data-dir":_vm.direction}},[_vm._t("aside")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }